import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@babackapp/ui/components/dialog";
import { Separator } from "@babackapp/ui/components/separator";
import useTranslation from "@babackapp/translations/use-translation";
import { PropsWithChildren, useState } from "react";
import { Button } from "@babackapp/ui/components/button";
import { ExclamationTriangleIcon } from "@radix-ui/react-icons";

export default function ConfirmRegenerateApiKey({
  children,
  onSubmit,
}: PropsWithChildren<{ onSubmit: () => void }>) {
  const t = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);

  const _handleSubmit = () => {
    setDialogOpen(false);
    onSubmit();
  };
  return (
    <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="pt-10">
        <DialogHeader>
          <DialogTitle>{t("settings.integrations.api.titlePopUp")}</DialogTitle>
          <DialogDescription>
            <span className="font-medium px-2 py-1 text-xs gap-2 inline-flex items-center text-destructive">
              <ExclamationTriangleIcon className="size-4" />
              <span>{t("settings.integrations.api.descPopUp")}</span>
            </span>
          </DialogDescription>
        </DialogHeader>

        <div className="flex justify-center gap-4">
          <Button
            className="w-1/2"
            onClick={() => setDialogOpen(false)}
            variant={"outline"}
          >
            {t("misc.cancel")}
          </Button>
          <Button
            variant={"default"}
            onClick={_handleSubmit}
            type="button"
            className="w-1/2"
          >
            {t("misc.confirm")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
